module.exports = __webpack_public_path__ + "img/zgwt_logo.78e95cce.png";